"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.upsertConfigOutputDtoSchema = exports.upsertGlobalConfigInputDtoSchema = exports.upsertOrganizationConfigInputDtoSchema = exports.upsertProjectConfigInputDtoSchema = exports.getEffectiveConfigOutputDtoSchema = exports.getEffectiveConfigInputDtoSchema = exports.assertionConfigurationDtoSchema = void 0;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const zod_1 = require("zod");
const configScopeSchema = sigma_engine_shared_1.RequirementsV2.ConfigScopeSchema;
exports.assertionConfigurationDtoSchema = zod_1.z.object({
    id: zod_1.z.string(),
    assertionDefinitionId: zod_1.z.string(),
    scope: configScopeSchema,
    scopeRefId: zod_1.z.string().nullable(),
    enabled: zod_1.z.boolean(),
    configuration: zod_1.z.unknown().optional(),
    createdAt: zod_1.z.date(),
    updatedAt: zod_1.z.date(),
});
exports.getEffectiveConfigInputDtoSchema = zod_1.z.object({
    assertionDefinitionId: zod_1.z.string(),
    projectId: zod_1.z.string(),
});
exports.getEffectiveConfigOutputDtoSchema = zod_1.z.object({
    row: exports.assertionConfigurationDtoSchema.nullable(),
    scope: configScopeSchema.nullable(),
});
exports.upsertProjectConfigInputDtoSchema = zod_1.z.object({
    assertionDefinitionId: zod_1.z.string(),
    projectId: zod_1.z.string(),
    enabled: zod_1.z.boolean().optional(),
    configuration: zod_1.z.unknown().optional(),
});
exports.upsertOrganizationConfigInputDtoSchema = zod_1.z.object({
    assertionDefinitionId: zod_1.z.string(),
    organizationId: zod_1.z.string(),
    enabled: zod_1.z.boolean().optional(),
    configuration: zod_1.z.unknown().optional(),
});
exports.upsertGlobalConfigInputDtoSchema = zod_1.z.object({
    assertionDefinitionId: zod_1.z.string(),
    enabled: zod_1.z.boolean().optional(),
    configuration: zod_1.z.unknown().optional(),
});
exports.upsertConfigOutputDtoSchema = exports.assertionConfigurationDtoSchema;
//# sourceMappingURL=configuration.dto.js.map